import {
    IProductCityLevelInventoryPayload,
    Vertical
  } from "../../interfaces/Index";

export const handleStockChange = (
    warehouseId: string,
    quantity: number, 
    index: number, 
    warehouseProductCityLevelInventory: IProductCityLevelInventoryPayload, 
    vertical: Vertical): any => {
    const fieldId: string = warehouseId;
    const fieldValue: number = quantity;
    
    const inventoryItem =
      warehouseProductCityLevelInventory.inventoryDetails.slice();
    inventoryItem[index].warehouseId = fieldId;
    if (vertical === Vertical.MARKETPLACE) {
      inventoryItem[index].quantity = fieldValue;
    } else if (vertical === Vertical.PRIME) {
      inventoryItem[index].primeQuantity = fieldValue;
    }

    return inventoryItem;
  };